import { ControlledSelectInput, FieldContainerWithLabel } from 'components';
import { useCounterparties } from './areaFormApi';
import { FC } from 'react';
import { Control } from 'react-hook-form';
import { SelectOptionType } from 'utils/types';

interface ConterpartySelectFieldProps {
  control: Control;
  edigasVersion?: number;
}

export const ConterpartySelectField: FC<ConterpartySelectFieldProps> = ({ control }) => {
  const { data: counterparties } = useCounterparties();

  return (
    <FieldContainerWithLabel>
      <p>Area responsible party</p>
      <ControlledSelectInput
        required
        control={control}
        width="20rem"
        placeholder="Choose"
        options={counterparties?.content as unknown as Array<SelectOptionType>}
        name="counterparty"
      />
    </FieldContainerWithLabel>
  );
};
